export default {
  items: [
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM158',
      name: 'Department/Station Master Selection',
      url: '/bcmuser/scorecardmasterselection',
      icon: ' icon-bcmUser_1'
    },
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM159',
      name: 'Department Info',
      url: '/bcmuser/departmentinfo/departmentinfolist',
      icon: ' icon-bcmUser_2'
    },
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM160',
      name: 'Minimum Business Continuity Objectives',
      url: '/bcmuser/mbco',
      icon: ' icon-bcmUser_3'
    },
    {
      moduleCode: 'BCM',
      screenCode: '',
      name: 'Business Impact Analysis',
      url: '/business_impact_analysis',
      icon: 'icon-bcmUser_4',
      class: 'parent-nav',

      children: [
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM161',
          name: 'Business Function',
          url: '/bcmuser/businessimpactanalysis/CBFList',
          icon: ' icon-bcmUser_4'
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM162',
          name: 'ICT Dependencies',
          url: '/bcmuser/itapplicationlisting',
          icon: ' icon-bcmUser_5'
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM163',
          name: 'Internal Dependencies',
          url: '/bcmuser/internaldependencies/internaldependencieslist',
          icon: ' icon-bcmUser_6'
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM164',
          name: 'External Dependencies',
          url: '/bcmuser/externaldependencies/externaldependencieslist',
          icon: ' icon-bcmUser_7'
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM165',
          name: 'Vital Record',
          url: '/bcmuser/cbf-vital-record',
          icon: ' icon-bcmUser_8'
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM166',
          name: 'Manual Workaround',
          url: '/bcmuser/manual-workaround-list',
          icon: ' icon-bcmUser_9'
        },
      ]
    },
    {
      moduleCode: 'BCM',
      screenCode: '',
      name: 'Active Command and Control Structure ',
      url: '/active_commad_and_control_structure',
      icon: 'icon-bcmUser_10',
      class: 'parent-nav',

      children: [
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM167',
          name: 'Emergency Response',
          url: '/bcmuser/emergencyresponse',
          icon: ' icon-bcmUser_10'
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM168',
          name: 'Emergency Operation Center',
          url: '/bcmuser/emergencycommandcenter',
          icon: ' icon-bcmUser_11'
        },
        {
          moduleCode: 'BCM',
          screenCode: 'BCMFRM169',
          name: 'Crisis Management Team',
          url: '/bcmuser/crisis-management-team',
          icon: ' icon-bcmUser_12'
        },
      ]
    },
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM170',
      name: 'Resource Requirement',
      url: '/bcmuser/resourcerequirement/resourcerequirementlist',
      icon: ' icon-bcmUser_15'
    },
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM171',
      name: 'Recovery Plan',
      url: '/bcmuser/riskscenario/riskscenariolist',
      icon: ' icon-bcmUser_14'
    },
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM172',
      name: 'Roles & Responsibilities',
      url: '/bcmuser/roles-and-responsibilities',
      icon: ' icon-bcmUser_13'
    },
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM173',
      name: 'Return To Normal Operation',
      url: '/bcmuser/return-to-normal-operation',
      icon: ' icon-bcmUser_16'
    },
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM174',
      name: 'Reference Record',
      url: '/bcmuser/reference-records',
      icon: ' icon-bcmUser_17'
    },
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM175',
      name: 'Audit Log',
      url: '/bcmuser/bcmauditlog',
      icon: ' icon-bcmUser_18'
    },
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM176',
      name: 'View History',
      url: '/bcmuser/historylist',
      icon: ' icon-bcmUser_19'
    },
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM177',
      name: 'Submission',
      url: '/bcmuser/submitforapproval',
      icon: ' icon-bcmUser_20'
    },
  ],
};

